import { type Theme } from '@mui/material/styles';

export const muiButton = {
  styleOverrides: {
    root: {
      position: 'relative',
      textTransform: 'unset',
    },
    contained: ({ theme }: { theme: Theme }) => ({
      padding: theme.spacing(0.75, 3),
    }),
    containedSizeLarge: ({ theme }: { theme: Theme }) => ({
      padding: theme.spacing(1, 4),
    }),
    containedSizeSmall: ({ theme }: { theme: Theme }) => ({
      padding: theme.spacing(0.5, 2),
    }),
    containedSecondary: ({ theme }: { theme: Theme }) => ({
      '&:hover': {
        backgroundColor: theme.palette.brand.vsuite.hover,
        textDecoration: 'none',
      },
    }),
    textSecondary: ({ theme }: { theme: Theme }) => ({
      color: theme.palette.brand.vsuite.text,
    }),
  },
};
